// Lightweight Web Audio API helpers for breath-phase chimes.
// Sine-wave tones with attack/decay envelopes — soft and unobtrusive.

let audioCtx = null;

function getCtx() {
  if (typeof window === "undefined") return null;
  const Ctx = window.AudioContext || window.webkitAudioContext;
  if (!Ctx) return null;
  if (!audioCtx) audioCtx = new Ctx();
  return audioCtx;
}

// Lazy unlock — call from any user gesture before audio plays
export function unlockAudio() {
  const ctx = getCtx();
  if (ctx && ctx.state === "suspended") ctx.resume().catch(() => {});
}

function playGlide(ctx, fStart, fEnd, duration, startAt, volume = 0.16) {
  const osc = ctx.createOscillator();
  const gain = ctx.createGain();
  osc.type = "sine";
  osc.frequency.setValueAtTime(fStart, startAt);
  osc.frequency.linearRampToValueAtTime(fEnd, startAt + duration);
  // Soft attack + decay envelope
  gain.gain.setValueAtTime(0, startAt);
  gain.gain.linearRampToValueAtTime(volume, startAt + 0.06);
  gain.gain.exponentialRampToValueAtTime(0.0001, startAt + duration);
  osc.connect(gain);
  gain.connect(ctx.destination);
  osc.start(startAt);
  osc.stop(startAt + duration + 0.05);
}

// Soft layered chime per phase — distinct timbre so the user can identify each
// phase with eyes closed.
export function playBreathChime(phase) {
  try {
    const ctx = getCtx();
    if (!ctx) return;
    if (ctx.state === "suspended") { ctx.resume().catch(() => {}); }
    const t = ctx.currentTime;

    if (phase === "INHALE") {
      // rising shimmer — A4 → E5 + soft fifth
      playGlide(ctx, 440, 659.25, 0.5, t, 0.14);
      playGlide(ctx, 880, 1318.5, 0.5, t + 0.02, 0.05);
    } else if (phase === "HOLD") {
      // single steady chime — D5
      playGlide(ctx, 587.33, 587.33, 0.35, t, 0.13);
      playGlide(ctx, 1174.66, 1174.66, 0.35, t + 0.01, 0.04);
    } else if (phase === "EXHALE") {
      // descending release — G4 → C4 + soft octave below
      playGlide(ctx, 392, 261.63, 0.8, t, 0.15);
      playGlide(ctx, 196, 130.81, 0.8, t + 0.02, 0.06);
    }
  } catch {
    // Audio is best-effort. Never break the UX if context creation fails.
  }
}
